export const TOAST_TYPE = {
  SUCCESS: 'success',
  ERROR: 'error',
  CUSTOM: 'custom',
  WARNING: 'warning',
};
